import { createSlice } from '@reduxjs/toolkit';

const planSlice = createSlice({
  name: 'plan',
  initialState: {
    reservation: null,
  },
  reducers: {
    setPlanReservation: (state, action) => {
      state.reservation = action.payload;
    },
    clearPlanReservation: (state) => {
      state.reservation = null;
    },
  },
});

export const { setPlanReservation, clearPlanReservation } = planSlice.actions;
export default planSlice.reducer;